<div class="empresa-consent-step">
  <div class="shield-icon">
    <mat-icon>verified_user</mat-icon>
  </div>

  <p class="main-question">
    <strong>Ahora validamos la identidad del representante legal</strong>
  </p>
  <p class="subtext">
    Este proceso esta disenado para verificar su identidad y protegerlo del robo
    de identidad.
  </p>

  <!-- Que se necesita -->
  <div class="requisitos">
    <div class="requisito" *ngFor="let req of requisitos">
      <div class="requisito-icon">
        <mat-icon>{{ req.icon }}</mat-icon>
      </div>
      <div class="requisito-content">
        <span class="requisito-title">{{ req.title }}</span>
        <span class="requisito-desc">{{ req.desc }}</span>
      </div>
      <div class="requisito-check">
        <mat-icon>check_circle</mat-icon>
      </div>
    </div>
  </div>

  <!-- Recomendaciones -->
  <div class="recommendation-box">
    <p class="rec-title">Recomendaciones</p>
    <ul>
      <li *ngFor="let rec of recomendaciones">
        <mat-icon>check</mat-icon>
        <span>{{ rec }}</span>
      </li>
    </ul>
  </div>

  <!-- Consentimiento biometrico -->
  <div class="consent-section">
    <input
      type="checkbox"
      id="biometric-consent"
      [checked]="consentGiven"
      (change)="onConsentChange($event)"
    />
    <label for="biometric-consent">
      Doy mi consentimiento para que Aguacate Wallet recopile, procese y comparta
      mi informacion personal, que puede incluir datos biometricos, como se
      establece en su Politica de privacidad.
    </label>
  </div>

  <!-- Acciones -->
  <div class="actions">
    <button
      type="button"
      class="continue-btn"
      (click)="start()"
      [disabled]="!consentGiven"
    >
      Empezar
    </button>
    <button type="button" class="back-btn" (click)="goBack()">Volver</button>
  </div>
</div>
